// Transitions
export const FORM_TRANSITION_PROGRESS_BAR = 'atRetirement/progressBar/transition/activePage';
export const activePage = () => ({ type: FORM_TRANSITION_PROGRESS_BAR });

// Events
export const PROGRESS_BAR_SET_VALUE = 'atRetirement/progressBar/setValue/';
export const ACTIVE_PAGE_SET_VALUE = PROGRESS_BAR_SET_VALUE + 'activePage';

export const setActivePageValue = value => ({ type: ACTIVE_PAGE_SET_VALUE, value });